import { render, staticRenderFns } from "./IntegrationTableItem.vue?vue&type=template&id=8a21b3e6&scoped=true"
import script from "./IntegrationTableItem.vue?vue&type=script&lang=js"
export * from "./IntegrationTableItem.vue?vue&type=script&lang=js"
import style0 from "./IntegrationTableItem.vue?vue&type=style&index=0&id=8a21b3e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a21b3e6",
  null
  
)

export default component.exports